import {
  WARRANTY_STATUS_LABELS,
  WORK_QUEUE_STAGE_LABELS,
  type Inspection,
} from '@/services/inspection.service';
import { CaseContextField, CaseContextFieldGrid } from './CaseContextField';

interface Props {
  inspection: Inspection | undefined;
}

export function InspectionContextPanel({ inspection }: Props) {
  return (
    <div className="rounded-xl border border-border bg-card">
      <div className="border-b border-border px-5 py-3.5">
        <h3 className="text-sm font-semibold text-foreground">Inspection Context</h3>
      </div>
      <div className="px-5 py-4">
        {!inspection ? (
          <p className="text-sm text-muted-foreground">Loading inspection context…</p>
        ) : (
          <CaseContextFieldGrid>
            <CaseContextField
              label="Customer"
              value={
                inspection.customerOrganizationName ?? inspection.customerName ?? 'Not recorded'
              }
            />
            <CaseContextField
              label="Location"
              value={inspection.customerLocationName ?? 'Not recorded'}
            />
            <CaseContextField label="Equipment" value={inspection.equipmentName} />
            <CaseContextField
              label="Brand"
              value={inspection.equipmentManufacturerName ?? 'Not recorded'}
            />
            <CaseContextField
              label="Model"
              value={inspection.equipmentModelName ?? 'Not recorded'}
            />
            <CaseContextField label="Serial Number" value={inspection.equipmentSerialNumber} />
            <CaseContextField
              label="Warranty"
              value={
                WARRANTY_STATUS_LABELS[inspection.warrantyStatus] +
                (inspection.warrantyTypeName ? ` — ${inspection.warrantyTypeName}` : '')
              }
            />
            <CaseContextField
              label="Current Status"
              value={WORK_QUEUE_STAGE_LABELS[inspection.currentStage]}
            />
            <div className="sm:col-span-2">
              <CaseContextField
                label="Complaint"
                value={inspection.intakeComplaintDescription ?? 'No complaint description recorded'}
              />
            </div>
          </CaseContextFieldGrid>
        )}
      </div>
    </div>
  );
}
